import React from "react"
import styles from "./dialogbox.module.css"
import { SimpleLayout } from "./layout"

import imageBackground from "../images/healthcare/background.svg"
import imageFeature from "../images/healthcare/feature.svg"
import imageBranding from "../images/healthcare/branding.svg"
import imageLanguage from "../images/healthcare/language.svg"

export default props => (
  <SimpleLayout style={{ background: "#F8F7FE" }}>
    <div className={styles.dialogbox}>
      <div className={styles.dialog}>
        <div className={styles.flexcolumn}>
          <h1>Have any specific requirements?</h1>
          <p>
            Want something done differently? Let us know if anything of the
            customisation areas below can be useful to you, and/or feel free to
            suggest anything else.
          </p>
        </div>
        <div className={styles.list}>
          <div className={styles.item}>
            <img src={imageBackground} alt="" />
            <h2>Background customisations</h2>
            <p>
              Customisation of environment, including different setting,
              different object positioning and more
            </p>
          </div>

          <div className={styles.item}>
            <img src={imageFeature} alt="" />
            <h2>Feature customisations</h2>
            <p>
              Addition of features to <br />
              the training content <br />
              that you think will be very useful
            </p>
          </div>

          <div className={styles.item}>
            <img src={imageBranding} alt="" />
            <h2>Branding & logo placement</h2>
            <p>
              Positioning of your organisation’s logo and/or branding in the
              virtual environment
            </p>
          </div>

          <div className={styles.item}>
            <img src={imageLanguage} alt="" />
            <h2>Language translation</h2>
            <p>
              Let us know if you <br />
              require the language of the app to be different from English
            </p>
          </div>
        </div>
      </div>
    </div>
  </SimpleLayout>
)
